import {Link} from "react-router-dom";
import React, {useState} from "react";
import DialogModal from '../DialogModal/DialogModal'
import {IRentalListByDayProps, IUser} from "./RentalInterfaces";

const statusClassMap: Record<string, string> = {
  'создан': 'created',
  'аренда': 'active',
  'обратная доставка': 'return',
  'закрыт': 'closed',
  'отменен': 'cancelled',
};

const RentalListByDay = ({filteredRentals, user, removeHandler}: IRentalListByDayProps) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);

  const openDialog = (id: number) => {
    setSelectedId(id);
    setDialogOpen(true);
  };

  const handleConfirm = (id?: number | string) => {
    if (typeof id === 'number') {
      removeHandler(id);
    }
  };

  const visibleRentals = [...filteredRentals]
    .sort((a, b) => b.id - a.id)
    .filter(
      (rental: any) =>
        user.role === 'admin' ||
        (user.role === 'courier' &&
          (rental.deliveries?.[0]?.courier_name === user.username ||
        rental.deliveries?.[1]?.courier_name === user.username))
    );

  if (visibleRentals.length === 0) {
    return null;
  }

  return (
    <>
      <ul className="rent-items list-group">
        {[...visibleRentals]
          .sort((a, b) => b.id - a.id)
          .map((rental: any) => (
            <li
              key={rental.id}
              className={`list-group-item rental-item rental-${statusClassMap[rental.status]}`}
              style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start'}}
            >
              <Link
                to={`/rental/${rental.id}`}
                style={{flex: 1, textDecoration: 'none', color: 'inherit'}}
              >
                <strong>#{rental.id} - {rental.status}</strong> <br/>
                {rental.product_name} — с {new Date(rental.start_date).toLocaleDateString('ru-RU')}{' '}
                {rental.end_date ? `по ${new Date(rental.end_date).toLocaleDateString('ru-RU')}` : ''}<br/>

                {rental.status !== 'обратная доставка' && rental.deliveries !== null && rental.deliveries.length === 1 && (
                  <>
                    <strong>Імʼя:</strong> {rental.deliveries[0].customer_name}<br/>
                    <strong>Тип доставки:</strong> {rental.deliveries[0].name}<br/>
                    {rental.deliveries[0].name !== 'Самовивіз' && (
                      <><strong>Адрес:</strong> {rental.deliveries[0].address}<br/></>
                    )}
                    <strong>Телефон:</strong> {rental.deliveries[0].phone}<br/>
                  </>
                )}

                {(rental.status === 'обратная доставка' || rental.status === 'закрыт') && rental.deliveries !== null && rental.deliveries.length === 2 && (
                  <>
                    <strong>Імʼя:</strong> {rental.deliveries[1].customer_name}<br/>
                    <strong>Тип доставки:</strong> {rental.deliveries[1].name}<br/>
                    {rental.deliveries[0].name !== 'Самовивіз' && (
                      <><strong>Адрес:</strong> {rental.deliveries[1].address}<br/></>
                    )}
                    <strong>Телефон:</strong> {rental.deliveries[0].phone}<br/>
                  </>
                )}
              </Link>
              {user.role === 'admin' && (
                <button
                  onClick={() => openDialog(rental.id)}
                  className={'remove-button'}
                  title="Видалити"
                >
                  🗑️
                </button>
              )}
            </li>
          ))}
      </ul>

      <DialogModal
        isOpen={dialogOpen}
        type="confirm"
        title="Підтвердження видалення"
        message={<>
          Ви впевнені, що хочете видалити оренду <strong>#{selectedId}?</strong>
        </>}
        id={selectedId ?? undefined}
        onClose={() => setDialogOpen(false)}
        onConfirm={(id: number | string | undefined) => {
          handleConfirm(id);
          setDialogOpen(false);
        }}
      />
    </>
  );
};

export default RentalListByDay;
